import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import FeedbackDialog from "@/components/feedback/FeedbackDialog";
import FeedbackRequestDialog from "@/components/feedback/FeedbackRequestDialog";
import { useEffect } from "react";
import { analytics } from "@/services/analytics/analyticsService";
import { useAuth } from "@/context/AuthContext";
import { useLocation } from "react-router-dom";

// Routes
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import Index from "@/pages/Index";
import SettingsPage from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import CreatePrompt from "@/pages/CreatePrompt";
import ExplorePage from "@/pages/ExplorePage";
import PromptDetailsPage from "@/pages/PromptDetailsPage";
import PromptEditor from "@/pages/EditPromptPage"; 
import CategoryPage from "@/pages/CategoryPage";
import AIChatPage from "@/pages/ai-chat/AIChatPage";
import SearchPage from "@/pages/SearchPage";
import ProductCopilotPage from "@/pages/product-copilot/ProductCopilotPage";
import PromptLibraryPage from "@/pages/PromptLibraryPage";
import PromptLabPage from "@/pages/PromptLabPage";
import UserProfilePage from "@/pages/UserProfilePage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import PopularPromptsPage from "@/pages/PopularPromptsPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import InvitationPage from "@/pages/InvitationPage";

function App() {
  const { user } = useAuth();
  const location = useLocation();
  
  // Set user ID when user changes
  useEffect(() => {
    if (user) {
      analytics.setUserId(user.id);
    } else {
      analytics.setUserId(null);
    }
  }, [user]);
  
  // Track page views when route changes
  useEffect(() => {
    // Use the core trackPageView method from AnalyticsCore that's inherited by AnalyticsService
    analytics.trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
  
  return (
    <>
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/create-prompt" element={<CreatePrompt />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/prompt/:promptId" element={<PromptDetailsPage />} />
          <Route path="/edit-prompt/:promptId" element={<PromptEditor />} />
          <Route path="/categories" element={<CategoryPage />} />
          <Route path="/ai-chat" element={<AIChatPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/product-copilot" element={<ProductCopilotPage />} />
          <Route path="/prompt-lab" element={<PromptLabPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/profile/:id" element={<UserProfilePage />} />
          
          {/* Auth callback routes */}
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          <Route path="/auth/invitation" element={<InvitationPage />} />
          
          {/* Fixed routes for footer links */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/popular" element={<PopularPromptsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </AnimatePresence>
      
      {/* Feedback components */}
      <FeedbackDialog />
      <FeedbackRequestDialog />
    </>
  );
}

export default App;
